import { db } from "@/firebase";
import store from "@/store"

const SessionService = {
	_keyForSong(song) {
		return store.state.currentUser.uid + ":" + song.songId;
	},

	setSong(song) {
		if (store.state.networkOnline) {
			db.collection("sessions").doc(store.state.currentUser.uid).update(song);
		}
	},

	createSession(sessionName) {
		var datetime = new Date();
		datetime.setHours(datetime.getHours() + 12);
		db.collection("sessions").doc(store.state.currentUser.uid).set({
			sessionName: sessionName,
			sessionDatetimeExpire: datetime
		});
	},

	removeSession() {
		db.collection("sessions").doc(store.state.currentUser.uid).delete();
	}
};

export {
	SessionService
};
